import {
  AlertingEntityType,
  AlertingMetricCondition,
  AlertingMetricValueType,
  AlertingPolicyActionCreate,
  ValueOf,
} from 'modules/Monitoring/types'

import { AlertingPolicyForm, AlertingPolicyThreshold } from '../types'

export const FormState = {
  Metrics: 'metrics',
  Actions: 'actions',
} as const
export type FormState = ValueOf<typeof FormState>

export const FORM_ID = 'queue-health-policy-form'
export const EMPTY_THRESHOLD: AlertingPolicyThreshold = {
  condition: AlertingMetricCondition.Greater,
  metricId: '',
  slackUsersAndGroups: [],
  value: {
    type: AlertingMetricValueType.Count,
    value: '',
  },
}
export const EMPTY_ACTION: AlertingPolicyActionCreate = {
  alertingActionId: '',
}
export const EMPTY_POLICY: AlertingPolicyForm = {
  alertingPolicyId: '',
  entityId: '',
  entityType: AlertingEntityType.Specialisation,
  slackChannel: '',
  thresholds: [EMPTY_THRESHOLD],
  alertingPolicyActions: [],
}
